<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.5 22.5">
    <g id="layout-11" transform="translate(0.25 0.25)">
      <rect
        id="Rectangle_192"
        data-name="Rectangle 192"
        width="9"
        height="11"
        transform="translate(0.5 0.5)"
        fill="none"
        :stroke="props.color"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <rect
        id="Rectangle_193"
        data-name="Rectangle 193"
        width="9"
        height="6"
        transform="translate(0.5 15.5)"
        fill="none"
        :stroke="props.color"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <rect
        id="Rectangle_194"
        data-name="Rectangle 194"
        width="9"
        height="7"
        transform="translate(12.5 0.5)"
        fill="none"
        :stroke="props.color"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <rect
        id="Rectangle_195"
        data-name="Rectangle 195"
        width="9"
        height="10"
        transform="translate(12.5 11.5)"
        fill="none"
        :stroke="props.color"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
interface DashboardProps {
  color?: string;
}

const props = withDefaults(defineProps<DashboardProps>(), {
  color: "#991e66",
});
</script>
